import { UsageWidgetLegend } from 'src/dashboard/Componets/UsageWidget';
import { UsageTypeValue } from 'src/common/components/UsageTypeSwitch/UsageTypeSwitch';
import { GraphsColorLegend } from 'src/common/components/GraphColorsLegend/GraphColorsLegend';
import { WidgetDailyUsageIndicator } from 'src/dashboard/Componets/WidgetDailyUpdateIndicator';
import { AreaChart } from 'src/common/components/Graphs/common/Graphs/AreaChart';
import { parseResponseDateAndTime } from 'common/utils/parseResponseDate';
import { usageTooltipValueFormatter } from 'src/common/utils/mapUsageDTOtoAreaChartData';
import { ChartTypeValue } from 'src/common/components/ChartTypeToggle/ChartTypeToggle';
import { ChartWithTypeAndUsageSelectWidget } from 'src/common/components/Graphs/common/Graphs/ChartWithTypeAndUsageSelectWidget';
import { useRSimUsageData } from './hooks/useRSimUsageData';
import { accountsFilterAtom } from 'src/atoms/filters/rsim-products';

import { GraphAccountsValidator } from 'src/products/GraphAccountValidator';
import { useAccountRefs } from 'src/common/components/Accounts/useAccountRefs';
import { UsageChartPlaceholder } from 'src/products/GraphValidatorPlaceholders';

const usageChartTooltipLabelOrder = {
  Allowance: 0,
  Total: 1,
  Upload: 2,
  Download: 3,
  MO: 2,
  MT: 3,
};

export const RSimUsageChartWidget = () => {
  const accountRefs = useAccountRefs({ cslAccountAtom: accountsFilterAtom });

  return (
    <GraphAccountsValidator accountRefs={accountRefs} fallback={<UsageChartPlaceholder />}>
      <ChartWithTypeAndUsageSelectWidget
        accountRef={accountRefs[0]}
        renderChart={(usageType, chartType, accountRef) => (
          <UsageChart usageType={usageType} chartType={chartType} accountRef={accountRef} />
        )}
      />
    </GraphAccountsValidator>
  );
};

type UsageChartProps = {
  accountRef: string;
  usageType: UsageTypeValue;
  chartType: ChartTypeValue;
};

const UsageChart = ({ accountRef, usageType, chartType }: UsageChartProps) => {
  const rsimUsageData = useRSimUsageData({
    accountRef: accountRef,
    chartType,
    usageType,
  });

  return (
    <>
      <UsageWidgetLegend>
        <GraphsColorLegend legendItems={rsimUsageData.legend} />
        <WidgetDailyUsageIndicator date={parseResponseDateAndTime(rsimUsageData?.lastUpdated)} />
      </UsageWidgetLegend>
      <AreaChart
        limitLabel="Allowance"
        datasets={rsimUsageData.datasets}
        limit={rsimUsageData.limit}
        yAxisLabel={rsimUsageData.yAxisLabel}
        xAxisLabels={rsimUsageData.xAxisLabels}
        realDataEndIndex={rsimUsageData.realDataEndIndex}
        tooltipValueFormatter={(value: number, unit?: string) =>
          usageTooltipValueFormatter(value, usageType, unit)
        }
        tooltipLabelPriority={usageChartTooltipLabelOrder}
      />
    </>
  );
};
